import AddPaymentMethod from '../../components/Account/AddPaymentMethod/AddPaymentMethod';

const AddPaymentMethodPage = () => {
	return <AddPaymentMethod />;
};

export default AddPaymentMethodPage;
